import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { useDemoOrgData } from "@/hooks/organization/useDemoOrgData";
import { DEF_JAM_ORG_ID } from "@/mockData/common/demoFilters";
import { PATH_ROOT } from "@/routes/paths";
import { useDemoOrg } from "@/contexts/DemoOrgContext";

import { markDemoWelcomeComplete } from "./demoWelcomeStorage";
import type { DemoWelcomeState } from "./types";

export function useDemoWelcomeLaunch() {
  const navigate = useNavigate();
  const demoOrg = useDemoOrg();
  const { organizations } = useDemoOrgData();

  return useCallback(
    async (state: DemoWelcomeState) => {
      await markDemoWelcomeComplete({
        email: state.email,
        name: state.name,
        role: state.role,
        industry: state.industry,
        orgName: state.orgName,
        mode: state.mode,
      });

      const defJam = organizations.find((org) => org.orgId === DEF_JAM_ORG_ID);
      if (state.mode === "create" && defJam) {
        await demoOrg?.setSelectedOrg(defJam);
      } else {
        await demoOrg?.setPersonalMode();
      }

      navigate(PATH_ROOT.demo.inbox);
    },
    [demoOrg, navigate, organizations],
  );
}

export async function navigateToDemoEntry(
  navigate: (path: string, options?: { replace?: boolean }) => void,
): Promise<void> {
  const { isDemoWelcomeComplete } = await import("./demoWelcomeStorage");
  const done = await isDemoWelcomeComplete();
  navigate(done ? PATH_ROOT.demo.inbox : PATH_ROOT.demo.welcome, {
    replace: false,
  });
}
